module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/16-63d0a32eda99821a5b5af658d822879c.png";